import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppService } from '../../../../../core/services/app.service';
import { DetailsOfaComponent } from '../../features/details-ofa/details-ofa.component';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FullscreenModeService } from '../../../../../core/services/fullscreen-mode.service';
import { LocalStorageService } from 'ngx-webstorage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedDataService } from '../../../../../core/services/shared-data.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ExcelService } from 'src/app/core/services/excel.service';
import swal from 'sweetalert2';
import * as FileSaver from 'file-saver';
import { DecimalPipe } from '@angular/common';
import {AppConfigService} from '../../../../../core/services/config.service';


@Component({
  selector: 'app-mon-arbitrage',
  templateUrl: './mon-arbitrage.component.html',
  styleUrls: ['./mon-arbitrage.component.css']
})

export class MonArbitrageComponent implements OnInit {

  public ICpage: any;
  public AMpage: any;
  public OEpage: any;
  public shouldShowValide: boolean;
  public shouldShowArbitrage: boolean;
  public shouldShowSoumis: boolean;
  public spinner: boolean;
  public isLoading = false;

  public _direction: any;
  public _structure: any;
  public _classification: any;
  public nom_prenoms: string;
  public matricule: string;
  public campagne_id: any;

  public statistics: any;
  public listMyOfa: any = [];
  public listIC: any = [];
  public listAM: any = [];
  public listOE: any = [];

  public listDR: any = [];
  public listStructureJ: any = [];
  public selectedAnalyse: any;
  public p = 1;
  public clickEventSubscription: Subscription;
  public filterForm: FormGroup;
  public submitted = false;
  public extended = false;
  public listStructure: any = [];

  public key = 'id'; // set default
  public selectedTab: any;
  public reverse = false;
  public loaderText: any;
  public filter: any;
  public response: any;
  public idStructure = 0;
  public dt: string;
  public ct: string;
  public user: any;
  public API_URL: any;
  public libelle_menu = 'Mon_arbitrage';
  public structureSelected = '';

  structureDataLoaded = false;

  constructor(
    private formBuilder: FormBuilder,
    private title: Title,
    private decimalPipe: DecimalPipe,
    private fullscreenService: FullscreenModeService,
    private _excelService: ExcelService,
    private modalService: NgbModal,
    private _loader: LoadingBarService,
    private _service: AppService,
    private toastrService: ToastrService,
    public configService: AppConfigService,
    private variable: GlobalVariableService,
    private storage: LocalStorageService,
    private sharedService: SharedDataService) {
    this.checkTabId();
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTableArbitrage().subscribe(() => {
      this.pageCallback();
    });
  }

  public ngOnInit(): void {
    this.API_URL = this.configService.get('HOST_API_ONLINE');
    this.user = JSON.parse(this.variable.getUser());
    this.structureSelected = this.user?.direction;
    this.title.setTitle('Mon arbitrage | HR Performance');
    this.filterForm = this.formBuilder.group({
      structure_id: [''],
      statut: [''],
      matricule: [''],
    });
    this.loadArbitrage();
  }

  loadArbitrage() {
    this.pageCallback();
  }

  onDropdownClick() {
    if (!this.structureDataLoaded) {
      this._service.getData(`gestion-ofas/directeurs/${this.GetStorage('idCampagneOfaSelected')}/structure-of-directeur`)
        .subscribe((res) => {
          this.listStructureJ = res.data;
          this.structureDataLoaded = true;
        });
    }
  }

  public GetStorage(key): any {
    const _data = this.storage.retrieve(key);
    if (_data) {
      try {
        return JSON.parse(_data);
      } catch (error) {
        console.error('Error parsing user JSON:', error);
      }
    } else {
      return;
    }
  }

  public getStatFormat(data): any {
    return this.decimalPipe.transform(data, '1.2-2');
  }

  public getStatusClasses(statut: string): { [key: string]: boolean } {
    return {
      'badge-info': statut === 'initialisé' || statut === 'soumis' || statut === 'appliqué' || statut === 'analysé',
      'badge-danger': statut === 'archivé' || statut === 'retourné',
      'badge-success': statut === 'arbitré' || statut === 'traité',
      'badge-warning': statut === 'en attente',
      'badge-valide': statut === 'validé',
      'badge-effectue': statut === 'effectué' || statut === 'démarré',
      'badge-accepte': statut === 'accepté',
      'badge-planifie': statut === 'planifié',
      'badge-approuve': statut === 'approuvé',
      'badge-revus': statut === 'revu',
      'badge-soumis': statut === 'soumis',
      'badge-100': statut !== 'planifié'
    };
  }

  public checkDirection(): string {
    const direction = this.user?.profil?.libelle;
    return direction != null ? (direction === 'Directeur' ? 'DG' : `${direction}`) : '--';
  }

  public getDisplayStatut(statut: string): string {
    return statut != null ? (statut === 'en attente' ? statut : `${statut}e`) : '--';
  }

  public thousandSeparator(value) {
    const spaces = value => String(value)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return value != null ? spaces(value) : '--';
  }


  // Post all FILTER
  public filtr(): void {
    this.pageCallback();
  }

  public checkTabId(): void {
    this.dt = localStorage.getItem('dt');
    this.ct = localStorage.getItem('ct');
  }

  public pageCallback(): void {
    const data = {
      nom_prenoms: this.nom_prenoms,
      matricule: this.matricule,
      direction_id: this._direction?.id,
      structure_ofa_code: this._structure?.code,
      campagne_ofa_id: this.storage.retrieve('idCampagneOfaSelected'),
    };
    this._loader.start();
    this._service
      .postData(`gestion-ofas/directeurs/mes-arbitrages?page=${this.p}`, data)
      .subscribe({
        next: (res: any) => {
          this._loader.stop();
          this.checkTabId();
          this.response = res['data'];
          this.statistics = this.response;
          this.listMyOfa = this.response['data'];
        },
        error: (error) => {
          this._loader.stop();
          this.toastrService.error(error.error.message);
        }
      });
  }

  public checkOfa(data, rubrique): any {
    const source = data?.fiches?.[rubrique]['data'];
    return source;
  }

  public checkPage(data, rubrique): any {
    const source = data?.fiches?.[rubrique];
    return source;
  }

  public onPageChange(event) {
    this.p = event;
    this.pageCallback();
  }

  public clearValue(): void {
    this._direction = '';
    this._structure = '';
    this.nom_prenoms = '';
    this.matricule = '';
  }


  public onChangeItem(item: any, type: string, ) {
    if (type === 'direction') {
      this.listStructureJ = [];
    } else if (type === 'structure') {
      this.structureSelected = item?.value?.code;
      return;
    } else {
      return;
    }
  }

  public onClearItem(type: string) {
    if (type === 'direction') {
      this.listStructureJ = [];
    } else if (type === 'structure') {
      this.structureSelected = this.user?.direction;
      return;
    } else {
      return;
    }
  }

  public tabChange($event: NgbTabChangeEvent, type): void {

    if (type === 'dt') {
      localStorage.setItem('dt', $event.nextId);
    } else if (type === 'ct') {
      localStorage.setItem('ct', $event.nextId);
    } else {
      return;
    }
    this.selectedTab = $event.nextId;
  }

  public get f() { return this.filterForm.controls; }

  // Submit Form
  public onSubmit() {
    this.submitted = true;
    if (this.filterForm.invalid) {
      return;
    }
    const data = {
      'structure_id': '',
      'statut': '',
      'matricule': '',
    };
  }

  public ouvrirOfa(data, typevue) {
    const modalRef = this.modalService.open(DetailsOfaComponent, { size: 'lg', windowClass: 'modal-adaptive' });
    modalRef.componentInstance.vue = 'arbitrage';
    modalRef.componentInstance.ofa = data;
    modalRef.componentInstance.test = typevue;
  }

  public toggleFullscreen(state) {
    if (state === 'full') {
      this.fullscreenService.showFullscreen();
      this.extended = !this.extended;
    } else {
      this.fullscreenService.hideFullscreen();
      this.extended = !this.extended;
    }
  }

  // Get all structure
  public getAllStructure(): void {
    this._loader.start();
    this._service.getData('structure/mes_structures').subscribe((data: {}) => {
      this._loader.stop();
      this.response = data;
      this.listStructure = this.response.data;
    });
  }


  public OnClickSynthese(id) {
    this.selectedAnalyse = this.listMyOfa.find(analyse => analyse.id === id);
  }

  // Get soumettre en masse
  public SoumettreMasse(id): void {

    const data = {
      structure_id: id,
      campagne_ofa_id: this.storage.retrieve('idCampagneOfaSelected'),
    };

    const actionFunction = (this.selectedAnalyse?.id === 0 && this.selectedAnalyse?.code === 'Synthese Globale') || !this._structure ?
      this._service.postData(`gestion-ofas/directeurs/synthese-globale/soumettre-masse-proposition-arbitrage`, data) :
      this._service.postData(`gestion-ofas/directeurs/structure/soumettre-masse-proposition-arbitrage`, data);

    swal.fire({
      title: `Êtes-vous sûr?`,
      text: 'Vous allez soumettre en masse toutes les propositions !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, soumettre!'
    }).then((result) => {
      if (result.value) {
        this._loader.start();
        this.loaderText = 'Soumission en cours';
        actionFunction.subscribe(
          res => {
            if (res.error === false) {
              this._loader.stop();
              this.toastrService.success(res.message);
              this.pageCallback();
              this.sharedService.sendRefreshTableAnalyse();
            } else {
              this.toastrService.error(res.message);
              this._loader.stop();
            }
          }, err => {
            this._loader.stop();
            console.log(err);
          }
        );
      }
    });
  }

  public exportData(data): void {
    const arrayAgent = [];
    for (let i = 0; i < data?.length; i++) {
      arrayAgent.push(
        {
          'Matricule': data[i].matricule,
          'Nom': data[i].nom,
          'Prénoms': data[i].prenom,
          'Categorie': data[i].categorie,
          'Salaire brut': data[i].salaire_brut,
          'Salaire net': data[i].salaire_net,
          'Appréciation EIA': data[i].appreciation_eia,
          'Proposition promotion': data[i].promo_categorie,
          'Proposition augmentation': data[i].aug_montant,
          'Taux gratification': data[i].gratif_taux,
          'Proposition gratification': data[i].gratif_montant,
          'Proposition bonus': data[i].bonus_montant,
          'Révision': data[i].revision,
          'Statut': data[i].statut,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayAgent, 'Liste des agents');
  }

  // Export global conseil de direction
  public exportGlobal() {
    this.isLoading = true;
    const header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: 'Bearer ' + this.variable.getAccessToken(),
    };

    const requestOptions = {
      headers: new Headers(header),
    };
    // this._loader.start();
    this.toastrService.info('La génération de l\'export est en cours');
    return fetch(this.API_URL + `gestion-ofas/directeurs/${this.storage.retrieve('idCampagneOfaSelected')}/export-recap-solde`, requestOptions)
      .then(res => res.blob()) // extract binary blob from response
      .then(blob => {
        this.isLoading = false;
        // Download blob with file-saver
        FileSaver.saveAs(blob, 'Export_global_mes_arbitrages.xlsx');
      })
      .catch((err) => { console.error('Excel download failed', err); this.isLoading = false; });
  }

}
